module.exports = __webpack_public_path__ + "static/media/twoweelericon.ceeed357.svg";